export function generateUniqueId(simple = false): string {
  const url = URL.createObjectURL(new Blob());
  const guid = url.substring(url.lastIndexOf(`/`) + 1);
  return simple ? guid.replaceAll(`-`, ``) : guid;
}
